import { Flex, For } from 'shared';

import {
  JournalFilterButton,
  JournalFilterSectionLabel,
  JournalFilterLabel,
  useJournalSprintFilterContext,
  JOURNAL_SPRINT_FILTERS,
} from 'features/journal';

export const JournalFilterBySprint = () => {
  const {
    pastSprints,
    handleAllSprintsClick,
    handleCurrentSprintClick,
    handlePastSprintClick,
    journalSprintFilterState,
  } = useJournalSprintFilterContext();

  return (
    <>
      <JournalFilterLabel>By sprint</JournalFilterLabel>
      <Flex gap="8px">
        <JournalFilterButton
          dataTestid="journal-sidebar-filter-current-sprint"
          isActive={!!journalSprintFilterState[JOURNAL_SPRINT_FILTERS.CURRENT]}
          onClick={handleCurrentSprintClick}
        >
          Current sprint
        </JournalFilterButton>
        <JournalFilterButton
          isActive={!!journalSprintFilterState[JOURNAL_SPRINT_FILTERS.ALL]}
          onClick={handleAllSprintsClick}
          dataTestid="journal-sidebar-filter-all-sprints"
        >
          All sprints
        </JournalFilterButton>
      </Flex>
      <JournalFilterSectionLabel>Past sprints</JournalFilterSectionLabel>
      <Flex gap="8px" flexWrap="wrap">
        <For each={pastSprints}>
          {({ title, sprintId }) => (
            <JournalFilterButton
              key={sprintId}
              dataTestid="journal-sidebar-filter-past-sprint"
              isActive={
                !!journalSprintFilterState[
                  `${JOURNAL_SPRINT_FILTERS.PAST}-${sprintId}`
                ]
              }
              onClick={() => handlePastSprintClick(sprintId)}
            >
              {title}
            </JournalFilterButton>
          )}
        </For>
      </Flex>
    </>
  );
};
